import React from "react";
import { WavyBackground } from "../components/ui/WavyBackground";
import Navbar from "../components/Navbar";
import Showcard from "../components/ui/Showcard";
// import { TextGenerateEffect } from "../components/ui/text-generate-effect";
import { StickyScroll } from "../components/ui/sticky-scroll-reveal";
import { CustomUrl } from "../components/Custbots";
import { Link } from "react-router-dom";
import { cn } from "../lib/utils";

const content = [
  {
    title: "Collaborative Editing",
    description:
      "Work together in real time with your team, clients, and stakeholders. Collaborate on documents, share ideas, and make decisions quickly. With our platform, you can streamline your workflow and increase productivity.",
    content: (
      <div className="h-full w-full bg-[linear-gradient(to_bottom_right,var(--cyan-500),var(--emerald-500))] flex items-center justify-center text-white">
        Collaborative Editing
      </div>
    ),
  },
  {
    title: "Real time changes",
    description:
      "See changes as they happen. With our platform, you can track every modification in real time. No more confusion about the latest version of your project. Say goodbye to the chaos of version control and embrace the simplicity of real-time updates.",
    content: (
      <div className="h-full w-full  flex items-center justify-center text-white">
        {/* <Image
          src="/linear.webp"
          width={300}
          height={300}
          className="h-full w-full object-cover"
          alt="linear board demo"
        /> */}
      </div>
    ),
  },
  {
    title: "Version control",
    description:
      "Experience real-time updates and never stress about version control again. Our platform ensures that you're always working on the most recent version of your project, eliminating the need for constant manual updates. Stay in the loop, keep your team aligned, and maintain the flow of your work without any interruptions.",
    content: (
      <div className="h-full w-full bg-[linear-gradient(to_bottom_right,var(--orange-500),var(--yellow-500))] flex items-center justify-center text-white">
        Version control
      </div>
    ),
  },
  {
    title: "Running out of content",
    description:
      "Experience real-time updates and never stress about version control again. Our platform ensures that you're always working on the most recent version of your project, eliminating the need for constant manual updates. Stay in the loop, keep your team aligned, and maintain the flow of your work without any interruptions.",
    content: (
      <div className="h-full w-full bg-[linear-gradient(to_bottom_right,var(--cyan-500),var(--emerald-500))] flex items-center justify-center text-white">
        Running out of content
      </div>
    ),
  },
];

function About() {
  const features = [
    {
      title: "Draggable",
      description: "draggable widgets",
      imagelink: "./images/Dragable-ss.webp",
    },
    {
      title: "Stats",
      description: "track your progress and streaks",
      imagelink: "./images/stats-ss1.webp",
    },
    {
      title: "Breathe",
      description: "stay calm between sessions",
      imagelink: "./images/Breathe-ss2.webp",
    },
    {
      title: "Study Together",
      description: "study with your friends",
      imagelink: "./images/study-together-ss3.png",
    },
    {
      title: "Themes",
      description: "customize however you like",
      imagelink:
        "https://wallpapers.com/images/hd/4k-andromeda-galaxy-68af0gq8brnv6qkk.webp",
    },
    {
      title: "Rooms",
      description: "connect and learn with friends",
      imagelink: "./images/Rooms-ss.webp",
    },
  ];
  const contentfeatures = [
    {
      title: "Draggable Widgets",
      description: "Customize your workspace effortlessly with draggable widgets.",
      content: (<div className="scrollcardimg" style={{
        backgroundImage:`url("${"./images/Dragable-ss.webp"}")`
      }}></div>),
    },
    {
      title: "Statistics",
      description: "Monitor your learning journey and track progress and streaks.",
      content: (<div className="scrollcardimg" style={{
        backgroundImage:`url("${"./images/stats-ss1.webp"}")`
      }}></div>),
    },
    {
      title: "Breathe Widget",
      description: "Stay centered and relaxed with tranquil breathing exercises.",
      content: (<div className="scrollcardimg" style={{
        backgroundImage:`url("${"./images/Breathe-ss2.webp"}")`
      }}></div>),
    },
    {
      title: "Study Together",
      description: "Collaborate and boost productivity by studying with your peers.",
      content: (<div className="scrollcardimg" style={{
        backgroundImage:`url("${"./images/study-together-ss3.png"}")`
      }}></div>),
    },
    {
      title: "Themes",
      description: "Personalize your experience with customizable themes.",
        content: (<div className="scrollcardimg" style={{
            backgroundImage:`url("${"https://wallpapers.com/images/hd/4k-andromeda-galaxy-68af0gq8brnv6qkk.webp"}")`
          }}></div>),
    },
    {
      title: "Rooms",
      description: "Connect with friends and create conducive learning environments.",
      content: (<div className="scrollcardimg" style={{
        backgroundImage:`url("${"./images/Rooms-ss.webp"}")`
      }}></div>),
    },
    {
      title: "",
      description: "",
      content: (<div className="scrollcardimg" style={{
        backgroundImage:`url("${"./images/Rooms-ss.webp"}")`
      }}></div>),
    },
  ];
  return (
    <div className="dark">
    <Navbar />
    <div
        className={cn(
          "absolute inset-0 -z-10",
          "[background-size:20px_20px]",
          "[background-image:radial-gradient(#d4d4d4_1px,transparent_1px)]",
          "dark:[background-image:radial-gradient(#404040_1px,transparent_1px)]",
        )}
      />
            <div className="-z-10 pointer-events-none absolute inset-0 flex items-center justify-center  [mask-image:radial-gradient(ellipse_at_center,transparent_10%,black)] bg-black"></div>

    <div className="hero-section gap-3 flex flex-col items-center justify-center py-5 max-w-5xl mx-auto " 
    
    >
      <h1 className="!text-7xl md:!text-9xl headingtitle text-[#f5e8c7] mb-1">
                      <span className="!text-8xl md:!text-[10rem] -mr-7 md:-mr-12">O</span>  takufy
                      </h1>
      
      <h2 className="text-sm md:text-xl text-muted-foreground px-3 text-center">
      The ultimate productivity app inspired by the Animedoro technique.
      </h2>
      <div className="flex items-center gap-2 mb-4 mt-2">
        <div className="flex -space-x-3">
          
          <Profile src={CustomUrl()} alt="Profile 4" />
          <Profile src={CustomUrl()} alt="Profile 4" />
          <Profile src={CustomUrl()} alt="Profile 4" />
          <Profile src={CustomUrl()} alt="Profile 4" />
          <Profile src={CustomUrl()} alt="Profile 4" />
          
        </div>
        <div className="opacity-90 ">Join 10,000+ otakus!</div>
      </div>
      
        <div>
          <button className="bg-neutral-950 px-3 py-2 md:!px-5 md:!py-3 rounded-full border hover:bg-neutral-900 transition-all duration-300">
            <Link className="font-mod text-sm md:text-base font-semibold hover:text-white hover:no-underline" to={localStorage.getItem("authToken") ? "/" : "/signup"}>
              Start Focusing 
            </Link>
          </button>
        </div>
       
      <div 
      className="w-[90%]  object-cover video-container shadow-xl shadow-white/10 rounded-xl "
      >
        <video 
          autoPlay 
          muted 
          loop
          className="mt-3 w-full h-full object-cover rounded-xl border !border-neutral-900"
            src="https://res.cloudinary.com/dtnnxs6kx/video/upload/v1745857357/rjtgjvr87efb7vpwiasc.mp4"
          >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>

    <div>

    <div className="max-w-7xl mx-auto px-4 py-16">
      <div className="text-center mb-16">
      <h3 className="text-3xl font-mod font-bold text-white mb-2">Connect with fellow 
      <span className='otaku-color ml-3 text-5xl headingtitle'>otakus!</span>
      </h3>
      <div className="  space-y-5  gap-4 md:!gap-8 flex justify-center items-center">
              <a 
              className='cursor-pointer hover:scale-110 transition-all'
                href="https://x.com/otakufy_live"
                target="_blank"
                rel="noopener noreferrer" 
                // className="flex items-center space-x-3 p-3 rounded-lg bg-neutral-800 hover:bg-neutral-700 transition-colors"
              >
                <img src="./images/x.png" alt="otakufy" className="w-24 h-24 mt-3 " />
              </a>
              <a
              className='cursor-pointer hover:scale-110 transition-all'
                href="https://discord.gg/NDbb6TUN"
                target="_blank"
                rel="noopener noreferrer"
                // className="flex items-center space-x-3 p-3 rounded-lg bg-neutral-800 hover:bg-neutral-700 transition-colors"
              >
                <img src="./images/discord.png" alt="discord" className="w-20 h-20 scale-105" />
              </a>
              <a
              className='cursor-pointer hover:scale-110 transition-all'
                href="https://www.instagram.com/otakufy.live/"
                target="_blank"
                rel="noopener noreferrer"
                // className="flex items-center space-x-3 p-3 rounded-lg bg-neutral-800 hover:bg-neutral-700 transition-colors"
              >
                <img src="./images/instagram.png" alt="instagram" className="w-24 h-24 scale-105" />
              </a>
            </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-[0.8fr_1.2fr] items-center gap-10">
        
        {/* Left Column */}
        <div className=" text-center md:text-left">
          <h2 className="text-5xl text-left md:text-6xl font-bold mb-4 headingtitle">
            What is Animedoro?
          </h2>
          <div className="font-mod text-sm md:text-base text-left text-neutral-300">
          Forget the traditional Pomodoro. Otakufy uses the Animedoro method: a productivity hack where you work for 40–60 minutes, then reward yourself with a short anime break (~20 minutes).
It's the perfect balance of discipline and motivation.
      </div>
        </div>

        {/* Right Column */}
        <div className=" ">
          <img 
            src="https://images4.alphacoders.com/121/1210824.jpg"
            alt="Otakufy Features"
            className="w-full  object-cover aspect-video rounded-xl shadow-lg border !border-neutral-600"
          />
        </div>

      </div>
      <div className="grid grid-cols-1 md:grid-cols-[1.3fr_0.7fr] items-center gap-10 md:!mt-32 mt-14 md:[&>*:first-child]:order-1 md:[&>*:last-child]:order-2 [&>*:first-child]:order-2 [&>*:last-child]:order-1">
        
        {/* Left Column */}
        <div className=" ">
          <img 
            src="./images/habit-cycle.png"
            alt="Habit cycle"
            className="w-full  object-cover aspect-video rounded-xl shadow-lg "
          />
        </div>

        {/* Right Column */}
        <div className=" text-center md:text-left">
          <h2 className="text-5xl text-left md:text-6xl font-bold mb-4 headingtitle">
            Why it works?
          </h2>
          <div className="font-mod text-sm md:text-base text-left text-neutral-300">
          Otakufy follows a proven habit loop:
          <div className="py-2 text-base md:text-lg font-bold">Cue → Routine → Reward → Repeat.</div>

          You start a study session, stay focused, and unlock an anime episode when you're done.
          This delayed reward triggers a dopamine boost after the work, helping your <strong className="otaku-color bg-neutral-900 py-1 px-2 rounded-md">🧠 brain</strong> link focus with 
          <span className="otaku-color bg-neutral-900 py-1 px-2 rounded-md">🏆 satisfaction</span>.
      </div>
        </div>
       

      </div>
    </div>
   


    </div>
    </div>
  );
}

export default About;


function Profile({ src, alt }) {
  return (
    <img 
      className="w-9 h-9 md:w-12 md:h-12 rounded-full ring-2 ring-black"
      src={src}
      alt={alt}
    />
  );
}
